import React from "react";

type Props = {
  msg: string;
};

const NoResults: React.FC<Props> = ({ msg }) => {
  return (
    <div>
      <p>{msg}</p>
    </div>
  );
};

export default NoResults;
